<template>
   <div>
     <section class="think-area responsive-content area-padding mid-top-padding">
       <div class="think-fluid">
         <div class="container">
           <div class="row">
             <div class="col-md-12">
               <div class="avivon-heading">
                 <h4 class="">
                   Seguimiento a reporte por robo o extravío.
                 </h4>
                 <p class="avivon__desc offer-title2 mt-20px mb-35px" v-if="onFolioView">
                   Por favor, ingresa tu correo o alias y el folio del reporte por robo o extravío que generaste previamente.
                   Si aún no tienes un reporte creado, puedes generarlo en la sección
                   <router-link :to="{name: 'reporteRoboExtravio'}" class="high-link">Reporte por robo o extravío</router-link>.
                 </p>
               </div>
             </div>
           </div>

           <div class="row" v-if="onFolioView">
             <div class="col-md-8">
               <div class="row" v-if="errorMssg != null">
                 <div class="col-md-12 error_text">
                   <p style="color:red; margin-bottom:10px; margin-top:0;">{{errorMssg}}</p>
                 </div>
               </div>

               <div class="row my-1">
                 <div class="col-md-10 form-group rg-form form-col">
                   <input type="text" v-model="username" class="form-control" placeholder="Correo o alias" v-on:keyup.enter="searchFolioRequest">
                 </div>
                 <div class="col-md-10 form-group rg-form form-col">
                   <input type="text" v-model="folio" class="form-control" placeholder="Folio del reporte" v-on:keyup.enter="searchFolioRequest">
                 </div>
               </div>
               <div class="row mb-10px mt-10px">
                 <div class="col-sm-12">
                   <vue-recaptcha
                     v-if="siteKey"
                     ref="vrecaptcha"
                     @verify="onVerify"
                     @expired="onExpired"
                     :sitekey="siteKey"></vue-recaptcha>
                 </div>
               </div>
               <div class="row">
                 <div class="col-sm-12 col-md-4 mt-3">
                   <button class="axil-btn btn-borderd btn-fluid btn-primary rg-style-button m-2" :class="{disabled: isLoading}" @click.stop="searchFolioRequest">
                     <template v-if="!isLoading">Buscar reporte</template>
                     <template v-if="isLoading">Buscando...</template>
                   </button>
                 </div>
               </div>
             </div>
           </div>

           <template v-if="onConfirmationView">
             <div class="row">
               <div class="col-md-12">
                 <div class="row">
                   <div class="col-md-12">
                     <p class="bold-inline mt-30px">Se ha encontrado el siguiente reporte por robo o extravío:</p>
                     <p class="xs-margin">Folio: <span class="bold-inline">{{reportInfo.folio}}</span></p>
                     <p class="xs-margin">Fecha de creación del reporte: <span class="bold-inline">{{reportInfo.created_at}}</span></p>
                     <p class="mt-30px rg-description-text">
                       Si deseas solicitar el reestablecimiento de tu cuenta, da clic en el botón <span class="bold-inline">Reestablecer cuenta</span>,
                       y dentro de las siguientes 24 horas se te proporcionará un correo para que puedas generar una nueva contraseña, así como
                       volver a configurar tu segundo factor de autenticación.
                     </p>
                   </div>
                 </div>

                 <div class="row" v-if="errorMssg != null">
                   <div class="col-md-12 error_text">
                     <p style="color:red; margin-bottom:10px; margin-top:0;">{{errorMssg}}</p>
                   </div>
                 </div>

                 <div class="row before-reg mt-15px">
                   <div class="col-sm-12 col-md-6 mt-3 display-flex">
                     <button class="axil-btn btn-borderd btn-fluid btn-primary rg-style-button m-2" @click.stop="doRequestResolution" :class="{disabled: isLoading}">
                       <template v-if="!isLoading">Reestablecer cuenta</template>
                       <template v-if="isLoading">Enviando...</template>
                     </button>
                     <button class="axil-btn btn-fluid btn-dark m-2" @click.stop="cancelResolution" v-if="!isLoading">Volver</button>
                   </div>
                 </div>
               </div>
             </div>
           </template>

           <template v-if="onSuccessView">
             <div class="row">
               <div class="col-md-12">
                 <div class="row">
                   <div class="col-md-12">
                     <p class="bold-inline mt-30px">Se ha procesado exitosamente la solicitud para reestablecer tu cuenta.</p>
                     <p class="mt-20px rg-description-text">
                       Dentro de las próximas 24 horas podrás reestablecer tu cuenta. Recibirás un correo para que puedas proporcionar una nueva contraseña
                       y así quede restablecida tu cuenta. Una vez que hayas iniciado sesión te solicitaremos registres de nuevo el segundo factor de autenticación.
                     </p>
                   </div>
                 </div>
               </div>
             </div>
           </template>

         </div>
       </div>
     </section>

   </div>
</template>

<script>
import VueRecaptcha from 'vue-recaptcha';
export default {
   name: "StealLossReportFollowUp",
   components: { VueRecaptcha },
   data () {
      return {
         errorMssg: null,
         isLoading: false,
         currentView: null,
         folio: null,
         username: null,
         siteKey: null,
         recaptcha: null,
         reportInfo: {
            id: null,
            folio: null,
            created_at: null,
            user_id: null,
         }
      }
   },
   created(){
      // constantes
      this.FOLIO_VIEW = 1
      this.CONFIRMATION_VIEW = 2
      this.SUCCESS_VIEW = 3
   },
   beforeMount(){
      this.currentView = this.FOLIO_VIEW
      this.siteKey = process.env.VUE_APP_RECPATCHA_SITE_KEY;
   },
   computed: {
      onFolioView() {
         return this.currentView === this.FOLIO_VIEW
      },
      onConfirmationView(){
         return this.currentView === this.CONFIRMATION_VIEW
      },
      onSuccessView(){
         return this.currentView === this.SUCCESS_VIEW
      },
      isPersonType1(){
         return this.userInfo.person_type === 1
      }
   },
   methods: {
      async searchFolioRequest(){
         if(this.folio != null && this.username != null){
            if(this.validateCaptcha()){
               await this.doSearchFolio();
            }
         }
         else {
            this.errorMssg = "Por favor, ingresa los datos requeridos reporte para realizar el seguimiento."
         }
      },
      async doSearchFolio(){
         this.errorMssg = null
         this.isLoading = true
         try {
            const payload = {
               user: this.username.trim(),
               folio: this.folio.trim(),
               recaptcha: this.recaptcha,
            }
            const res = await this.publicApiPost('/api/compliance/ume/stealLossReport/search', payload);
            this.reportInfo = res.data.report;
            this.currentView = this.CONFIRMATION_VIEW
         }
         catch (e) {
            this.resetRecaptcha()
            this.errorMssg = this.catchErrorMessage(e)
         }
         this.isLoading = false
      },
      async doRequestResolution(){
         this.errorMssg = null
         this.isLoading = true
         try {
            const payload = {
               user_id: this.reportInfo.user_id,
               report_id: this.reportInfo.id
            }
            const res = await this.publicApiPost('/api/compliance/ume/stealLossReport/resolutionRequest', payload);
            this.currentView = this.SUCCESS_VIEW
         }
         catch (e) {
            this.errorMssg = this.catchErrorMessage(e)
         }
         this.isLoading = false
      },
      cancelResolution(){
         this.resetForm()
         this.currentView = this.FOLIO_VIEW
      },
      resetForm(){
         this.folio = null
         this.errorMssg = null
         this.username = null
         this.recaptcha = null
         this.reportInfo = {
            id: null,
            folio: null,
            created_at: null,
            user_id: null,
         }
      },
      catchErrorMessage(e){
         if(e && e.response && e.response.data && e.response.data.mensaje){
            return e.response.data.mensaje
         }
         else {
            return "Ha ocurrido un error con la petición, por favor intenta más tarde."
         }
      },
      validateCaptcha(){
         if(this.recaptcha == null){
            this.errorMssg = "Por favor completa la verificación 'No soy un robot'."
            return false
         }
         return true
      },
      onVerify(response){
         this.recaptcha = response;
      },
      onExpired(){
         this.recaptcha = null
      },
      resetRecaptcha(){
         this.recaptcha = null
         this.$refs.vrecaptcha.reset()
      }
   }
}
</script>
